module.exports = __webpack_public_path__ + "static/img/icon_arg.d8b594cf.png";